import { h, Component } from 'preact';
import style from './style';
import ReactGA from 'react-ga';
import DownloadModal from '../downloadModal';
// import TermOfUserPdf from '../../static/assets/termofuse.pdf';

export default class Footer extends Component {
    constructor(props) {
		super(props);
		this.state = {
            headerClass: style.header,
			showDownload: false,
		};
    }
    closeDownload = () => {
        this.setState({ showDownload: false });
	}

    innerMenuClick = (type) => {
		if (type === 'download') {
			this.setState({ showDownload: true });
		}

		document.body.style.overflowY = 'scroll';
    }


    renderDownloadBox = () => {
        let {showDownload} = this.state;
        return showDownload ? <DownloadModal onCloseModal={() => this.closeDownload()} /> : null;
    }


    render() {
        var currentYear = new Date().getFullYear()
        return (
            <footer class={style.footer}>
                <a target="_blank" href="https://www.iucn.org/"
                    onclick={() => ReactGA.ga('send',
                        'event',
                        'External Links',
                        'IUCN Logo',
                        '')}
                >
                    <img class={style.whiteLogo} src="/static/assets/images/white-logo.png" alt=
                        "white-logo" />
                </a>
                <ul class={style.linkSection}>
                    <li class={style.linkItems}><a class={style.footerLink}
                        onclick={() => ReactGA.ga('send',
                            'event',
                            'External Links',
                            'About us',
                            '/about-us')}
                        target="_blank" href="/about-us">About IUCN Open Project portal</a></li>
                         <li class={style.linkItems}><a  href='/static/assets/images/termofuse.pdf' target = "_blank" class={style.footerLink} 
                        onclick={() => ReactGA.ga('send',
                            'event',
                            'External Links',
                            'Terms of use',
                            '#')}
                       >Terms of use</a></li>
                    <li class={style.linkItems} onClick={() => { this.innerMenuClick('download'); }}>
						<a class={style.footerLink}>Download</a>
                    </li>
                    {
                        this.renderDownloadBox()
					}
                </ul>
              <p class={style.copyrightDetails}>©{currentYear} IUCN, International Union for Conservation of Nature</p>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./components/footer/index.js